import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MappingRow } from 'src/app/admin-panel/admin-panel.component';
import { Logbook } from 'src/app/data-models/user-models/logbook.model';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';


export function duplicateVrnValidator(vrns: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return vrns.includes(control.value) ? { duplicate: true} : null;
  };
}

@Component({
    selector: 'app-edit-mapping-dialog',
    templateUrl: './edit-mapping-dialog.component.html',
    styleUrls: ['./edit-mapping-dialog.component.css'],
    standalone: false
})
export class EditMappingDialogComponent implements OnInit {

  constructor (
    public dialogRef: MatDialogRef<EditMappingDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: { vrns: string[], logbooks: Logbook[], type: string, isNew: boolean, value: MappingRow, editedLbs: Logbook[] }
  ) {}


  mappingForm: UntypedFormGroup = new UntypedFormGroup({
    logbookIndexes: new FormControl<number[]>([]),
    fin: new FormControl<string>(''),
    vesselNumber: new FormControl<string>('', Validators.required),
  });

  ngOnInit(): void {
    if (!this.data.isNew) {
      this.mappingForm.patchValue({
        logbookIndexes: this.data.editedLbs.map(lb => this.data.logbooks.indexOf(lb)),
        fin: this.data.value.fin,
        vesselNumber: this.data.value.vrn
      });
      if (this.data.type == 'fin-vrn') this.mappingForm.get('fin')?.disable();
      else this.mappingForm.get('vesselNumber')?.disable();
    }
    
    if (this.data.type == 'fin-vrn') {
      this.mappingForm.get('fin')?.addValidators(Validators.required);
    } else {
      this.mappingForm.get('vesselNumber')?.addValidators(duplicateVrnValidator(this.data.vrns));
      this.mappingForm.get('logbookIndexes')?.addValidators(Validators.required);
    }
    this.mappingForm.updateValueAndValidity(); 
  }


  returnResult() {
    if (this.mappingForm.valid) {
      this.mappingForm.get('fin')?.enable();
      this.mappingForm.get('vesselNumber')?.enable();
      this.dialogRef.close(this.mappingForm.value)
    } 
    else this.mappingForm.markAllAsTouched();
  }


  deleteRecord() {
    this.dialog.open(ConfirmationDialogComponent, {
      data: { screen: this.data.type == 'fin-vrn' ? 'delete_fin_vrn_mapping' : 'delete_vrn_lb_mapping' }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.dialogRef.close({logbookIndexes: this.data.editedLbs.map(lb => this.data.logbooks.indexOf(lb)), fin: this.data.value.fin, vesselNumber: this.data.value.vrn, delete: true})
      }
    })
  }

}
